export const validatorMixin = {
  methods: {
    isAllowedFile: function (fileName) {
      let allowedExtensions = ['stl']
      let fileExtension = fileName.substring(fileName.indexOf('.') + 1, fileName.length)

      return allowedExtensions.indexOf(fileExtension) > -1
    },
    isInteger: function (value) {
      return /^[0-9]+$/.test(value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/validatorMixin.js